import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT as hi, GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT as li } from "../common/constants.js";
var ni = /*#__PURE__*/function () {
  function ni() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var e = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var r = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {
      enabled: !1
    };
    var a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {
      enabled: !1,
      refresh_rate_limit: void 0
    };
    var n = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {
      enabled: !0,
      capacity: hi,
      refill_rate: li,
      endpoint_overrides: {}
    };
    var o = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
    _classCallCheck(this, ni);
    this.ol = t, this.bl = i, this.fl = s, this.vl = h, this.Cl = e, this.dl = l, this.gl = r, this.he = a, this.ml = n, this.banners = o, this.ol = t, this.bl = i, this.fl = s, this.vl = h, this.Cl = e, this.dl = l, this.gl = r, this.he = a, this.ml = n, this.banners = o;
  }
  _createClass(ni, [{
    key: "dt",
    value: function dt() {
      return {
        s: "6.2.0",
        l: this.ol,
        e: this.bl,
        a: this.fl,
        p: this.vl,
        m: this.Cl,
        v: this.dl,
        c: this.gl,
        f: this.he,
        grl: this.ml,
        b: this.banners
      };
    }
  }], [{
    key: "qn",
    value: function qn(t) {
      var i = t.l;
      return "6.2.0" !== t.s && (i = 0), new ni(i, t.e, t.a, t.p, t.m, t.v, t.c, t.f, t.grl, t.b);
    }
  }]);
  return ni;
}();
export { ni as default };